module.exports = __webpack_public_path__ + "img/larke.fae9b1e8.png";